import React from "react";
import AddAssignmentTemplateCustomerModal from "features/Dealers/DealerDetails/AdditionalDocuments/AddAssignmentTemplateCustomerModal";
import {
  getAssignmentTemplatesCustomer,
  approveAdditionalDocument,
  downloadAdditionalDocument,
} from "features/Dealers/DealerDetails/AdditionalDocuments/actions";
import AdditionalDocumentTable from "features/AdditionalDocuments/AdditionalDocumentTable";

const AssignmentTemplateCustomer = ({ dealerId }) => {
  return (
    <AdditionalDocumentTable
      dealerId={dealerId}
      loadAction={getAssignmentTemplatesCustomer}
      emptyMessage="No Assignment Template from Customer"
      AddModal={AddAssignmentTemplateCustomerModal}
      approveAction={approveAdditionalDocument}
      downloadAction={downloadAdditionalDocument}
    />
  );
};

export default AssignmentTemplateCustomer;
